import {ReactNode} from 'react';
import styled from 'styled-components';
import {interceptProps} from '@/styled-components';
import {LAYOUT_SIZE} from '@/styles';
import {Handle, SidePanelWrapper} from './StyledComponents';

interface IProps {
  open: boolean;
  hasHandle?: boolean;
  children?: ReactNode;
  onChangeState(open?: boolean): void;
}

export const SidePanel = ({
  open,
  hasHandle,
  children,
  onChangeState,
}: IProps) => {
  return (
    <Drawer open={open}>
      {children}
      {hasHandle && <Handle open={open} onClick={() => onChangeState(!open)} />}
    </Drawer>
  );
};

const Drawer = styled(SidePanelWrapper).withConfig({
  shouldForwardProp: interceptProps(['open']),
})<{
  open: boolean;
}>`
  ${({open}) =>
    !open && `left: ${LAYOUT_SIZE.SIDE_BAR - LAYOUT_SIZE.SIDE_PANEL}px;`}
`;
